import { IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'

import { getTranslate } from '../../localization'
import { ProviderBrief } from '../../types/provider'
import ProviderRow from './ProviderRow'
import ProviderRowSkeleton from './ProviderRow.skeleton'
import useStyles from './styles/TemplatesTable.styles'

interface ProvidersTableProps {
  loading: boolean
  data: ProviderBrief[]
  reloadData: () => void
}

export const ProvidersTable: React.FC<ProvidersTableProps> = ({
  loading,
  data,
  reloadData
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.tableHead}>
        <div>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div>
          <Typography variant="body1">{getTranslate('Code')}</Typography>
        </div>
        <div className={classes.refreshButtonContainer}>
          <IconButton
            onClick={() => {
              reloadData()
            }}>
            <RefreshIcon fontSize="small" />
          </IconButton>
        </div>
      </div>
      {loading
        ? Array(5)
            .fill(null)
            .map((item, index) => (
              <ProviderRowSkeleton
                key={`template-row-skeleton${index.toString()}`}
              />
            ))
        : data.map((singleProvider, index) => (
            <ProviderRow key={index} data={singleProvider} />
          ))}
    </div>
  )
}

export default ProvidersTable
